import axios from 'axios'

/**
 * PUTs a file to a presigned S3 URL.
 *
 * Must NOT go through the app's default axios instance: setupAxios installs a
 * request interceptor that attaches `Authorization: Bearer <jwt>` to every
 * request, and S3 rejects requests that carry both a query-string signature
 * (X-Amz-Signature) and an Authorization header with
 * `400 InvalidArgument: Only one auth mechanism allowed`. The bare header
 * also forces a CORS preflight for `authorization` that upload buckets do
 * not allowlist. A fresh instance from axios.create() shares no interceptors
 * with the default one.
 */
const s3Client = axios.create()

export const putToSignedUrl = (uploadURL: string, body: ArrayBuffer | Blob, contentType?: string) =>
  s3Client.put(uploadURL, body, contentType ? {headers: {'Content-Type': contentType}} : undefined)
